/* eslint-disable no-restricted-imports */
import React, { useRef } from 'react';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Text,
} from '@chakra-ui/react';
import { Button } from 'src/components/atoms/Button';

type DisconnectDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  channelName: string;
  isLoading: boolean;
};

export const DisconnectDialog: React.FC<DisconnectDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  channelName,
  isLoading,
}) => {
  const cancelRef = useRef<HTMLButtonElement>(null);

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent bg="surface.panel">
          <AlertDialogHeader
            fontFamily="marketingPage"
            fontWeight="bold"
            fontSize="lg"
            color="content.title">
            Disconnect Channel
          </AlertDialogHeader>
          <AlertDialogBody>
            <Text>
              Are you sure you want to disconnect <strong>{channelName}</strong>
              ?
            </Text>
            <Text mt={2} color="content.muted" fontSize="sm">
              You will need to reconnect and re-authorize access to resume data
              syncing.
            </Text>
          </AlertDialogBody>
          <AlertDialogFooter gap={3}>
            <Button
              ref={cancelRef}
              onClick={onClose}
              buttonName="cancel-disconnect"
              variant="ghost">
              Cancel
            </Button>
            <Button
              onClick={onConfirm}
              isLoading={isLoading}
              buttonName="confirm-disconnect"
              sx={{
                bg: 'background.red.500',
                color: 'white',
                _hover: { bg: 'red.600' },
              }}>
              Disconnect
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
